/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ object: NonNullable<unknown>, status: NonNullable<unknown> }} Bell_Follow_StatusInputs */

const en_bell_follow_status = /** @type {(inputs: Bell_Follow_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.object} is now ${i?.status}`)
};

/**
* | output |
* | --- |
* | "{object} is now {status}" |
*
* @param {Bell_Follow_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_follow_status = /** @type {((inputs: Bell_Follow_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Follow_StatusInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_follow_status(inputs)
});